import store from '@/state/store'

export default async (to, from, next) => {

    //get sacrificer code.
    let code = to.params.code;

    //call with mubin api for validate code.
    const status = await store.dispatch('authSacrificer/validate', {
        code : code
    });
  
    if(status == 200){
        // yes => that mean in mbin db exists sacrificer.
        next() 
    }else{
        // no => that mean in mubin db dos't exists sacrificer.
        //return to home page.
        next({name: 'default'}) 
    }
}